import {Quaternion,Euler} from "three";
import {toRadians} from "math-toolbox";

export function applyRotation (object3D,deltaMove,multiplierX = 1,multiplierY = 1){

    if (!object3D)return

    var deltaRotationQuaternion = new Quaternion()
        .setFromEuler(new Euler(
            toRadians(deltaMove.y * multiplierY),
            toRadians(deltaMove.x * multiplierX),
            0,
            'XYZ'
        ));

    object3D.quaternion.multiplyQuaternions(deltaRotationQuaternion, object3D.quaternion);


}